module.exports = __webpack_public_path__ + "img/9788959522774.90f40612.jpg";